// Service Index 

// Base Service
export { BaseService } from './BaseService.js';

// Core Services - nur Klassen exportieren
export { AuthService } from './AuthService.js';
export { CustomerService } from './CustomerService.js';
export { PlatformService } from './PlatformService.js';
export { BookingService } from './BookingService.js';
export { InvoiceService } from './InvoiceService.js';
export { CalendarService } from './CalendarService.js';
export { ContentService } from './ContentService.js';
export { SettingsService } from './SettingsService.js';

// Email & Payment Services
export { EmailService } from './EmailService.js';
export { PaymentService } from './PaymentService.js';

// Import Klassen für Instanz-Erstellung
import { AuthService } from './AuthService.js';
import { CustomerService } from './CustomerService.js';
import { PlatformService } from './PlatformService.js';
import { BookingService } from './BookingService.js';
import { InvoiceService } from './InvoiceService.js';
import { CalendarService } from './CalendarService.js';
import { ContentService } from './ContentService.js';
import { SettingsService } from './SettingsService.js';
import { EmailService } from './EmailService.js';
import { PaymentService } from './PaymentService.js';

// Erstelle Service-Instanzen lazy
let _authService = null;
let _customerService = null;
let _platformService = null;
let _bookingService = null;
let _invoiceService = null;
let _calendarService = null;
let _contentService = null;
let _settingsService = null;
let _emailService = null;
let _paymentService = null;

// Lazy Service Getters
export const authService = () => _authService || (_authService = new AuthService());
export const customerService = () => _customerService || (_customerService = new CustomerService());
export const platformService = () => _platformService || (_platformService = new PlatformService());
export const bookingService = () => _bookingService || (_bookingService = new BookingService());
export const invoiceService = () => _invoiceService || (_invoiceService = new InvoiceService());
export const calendarService = () => _calendarService || (_calendarService = new CalendarService());
export const contentService = () => _contentService || (_contentService = new ContentService());
export const settingsService = () => _settingsService || (_settingsService = new SettingsService());
export const emailService = () => _emailService || (_emailService = new EmailService());
export const paymentService = () => _paymentService || (_paymentService = new PaymentService());

// Service collection mit Lazy Loading
export const services = {
  get auth() { return authService(); },
  get customers() { return customerService(); },
  get platforms() { return platformService(); },
  get bookings() { return bookingService(); },
  get invoices() { return invoiceService(); },
  get calendar() { return calendarService(); },
  get content() { return contentService(); },
  get settings() { return settingsService(); },
  get email() { return emailService(); },
  get payment() { return paymentService(); }
};

export default services; 